"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var efficient_frontier_chart_1 = require("./efficient-frontier.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var EfficientFrontierComponent = /** @class */ (function (_super) {
    __extends(EfficientFrontierComponent, _super);
    function EfficientFrontierComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'EfficientFrontier') || this;
        _this.changeLabelLength = function (change) {
            if (change === void 0) { change = 0; }
            var ctrl = _this;
            if (!ctrl.settings.charsInLabel) {
                ctrl.settings.charsInLabel = 0;
            }
            ctrl.settings.charsInLabel = parseInt(ctrl.settings.charsInLabel);
            ctrl.settings.charsInLabel += change;
            ctrl.drawChart();
        };
        var ctrl = _this;
        $scope.$on('command:EFFICIENT_FRONTIER', function (event, args) { return ctrl.initComponent(event, args); });
        return _this;
    }
    EfficientFrontierComponent.prototype.getChartOptions = function (graph, options) {
        return efficient_frontier_chart_1.getChartOptions(graph, options);
    };
    EfficientFrontierComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("./efficient-frontier.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], EfficientFrontierComponent);
    return EfficientFrontierComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.EfficientFrontierComponent = EfficientFrontierComponent;
angular.module('smartorg.r6.acts.efficientFrontier', []).component('efficientFrontier', EfficientFrontierComponent);
module.exports = 'smartorg.r6.acts.efficientFrontier';
//# sourceMappingURL=efficient-frontier.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/efficient-frontier/efficient-frontier.component.js